<div class="initiative-dialog">
  <div class="title">
    @if (!!character) {
      <span class="character">
        <img class="icon" [src]="character.iconUrl" />
        {{ gameManager.characterManager.characterName(character) }}
        @if (character.title) {
          <span>&nbsp;(<span [ghs-label]="'data.character.' + character.edition + '.' + character.name"></span>)</span>
        }
      </span>
    }
    @if (!!objective) {
      <span class="character">
        <img class="icon" [src]="'./assets/images/objective/' + (objective.escort ? 'escort' : 'objective') + '.svg'" />
        @if (objective.title) {
          <span> {{ objective.title }}</span>
        }
        @if (!objective.title) {
          <span [ghs-label]="objective.name ? 'data.objective.' + objective.name : objective.escort ? 'escort' : 'objective'"></span>
        }
        @if (objective.title) {
          <span>&nbsp;<span [ghs-label]="objective.escort ? 'escort' : 'objective'"></span></span>
        }
      </span>
    }
    <span [ghs-label]="'game.figure.setInitiative'"></span>
  </div>

  <div class="number-container">
    <span></span>
    <span class="value">{{ value }}</span>
    <span></span>
    @for (number of [1, 2, 3, 4, 5, 6, 7, 8, 9]; track number) {
      <span class="number-button" (click)="pickNumber(number)">
        <span class="number">{{ number }}</span>
      </span>
    }
    <span></span>
    <span class="number-button" (click)="pickNumber(0)">
      <span class="number">0</span>
    </span>
    <span></span>
  </div>
  @if (!!character) {
    <span class="long-rest-button" [ngClass]="{ active: character.longRest }" (click)="longRest()">
      <img class="ghs-svg" src="./assets/images/long-rest.svg" />
      <span [ghs-label]="'game.figure.longRest' + (character.longRest ? 'Off' : '')"></span>
    </span>
  }
</div>
